/** `users.feature_flag.key` for GUIDE-S follow-up UI and recap. */
export const GUIDE_S_FRAMEWORK_FEATURE_FLAG = 'guide-s-framework';
